var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27131 2.04562C8.96678 -0.681873 12.9363 -0.681872 14.6318 2.04562L21.2431 12.6812C23.0375 15.5678 20.9617 19.3023 17.5629 19.3023H4.34023C0.941407 19.3023 -1.13436 15.5678 0.659995 12.6812L7.27131 2.04562ZM10.9518 6.30216C11.5501 6.30216 12.0352 6.78719 12.0352 7.3855V10.6355C12.0352 11.2338 11.5501 11.7188 10.9518 11.7188C10.3535 11.7188 9.86849 11.2338 9.86849 10.6355V7.3855C9.86849 6.78719 10.3535 6.30216 10.9518 6.30216ZM9.59766 13.8855C9.59766 13.1376 10.2039 12.5313 10.9518 12.5313C11.6997 12.5313 12.306 13.1376 12.306 13.8855C12.306 14.6334 11.6997 15.2397 10.9518 15.2397C10.2039 15.2397 9.59766 14.6334 9.59766 13.8855Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1cb8d61aaf59bf77d45540a6058d3c4a.svg";
export { ForwardRef as ReactComponent };